export default __webpack_public_path__ + "static/media/takuhai_truck_man.500aeb63.png";